import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/oportunidades/header/Header";
import Midia from "../../components/oportunidades/midia/Midia";
import DetalhesOportunidade from "../../components/oportunidades/detalhesOportunidade/DetalhesOportunidade";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import { DashboardLayout, MainContent } from "../dash/styles";
import { Container } from "./styles";
import dayjs from "dayjs";



const getImagemUrl = (imagem) => {
  if (!imagem) return "https://placehold.co/600x200?text=Sem+Imagem";
  if (imagem.startsWith("http")) return imagem;

  const baseURL = api.defaults.baseURL;
  return `${baseURL}/${imagem.replace(/^\/?/, "")}`;
};

export default function EditarOportunidades() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [oportunidadeData, setOportunidadeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOportunidade = async () => {
      try {
        const response = await api.get(`/api/content/oportunidades/${id}`);
        const op = response.data;

        setOportunidadeData({
          titulo: op.titulo || "",
          descricao: op.descricao || "",
          organizador: op.organizador || "",
          empresa: op.empresa || "",
          cargo: op.cargo || "",
          local: op.local || "",
          status: op.status || "Upcoming",
          salario: op.salario || "",
          horaTrabalho: op.horaTrabalho || "",
          dataInicio: op.dataInicio ? dayjs(op.dataInicio.$date || op.dataInicio) : null,
          dataFim: op.dataFim ? dayjs(op.dataFim.$date || op.dataFim) : null,
          destacado: Boolean(op.destacado),
          conteudos: op.conteudos?.length ? op.conteudos : [{ titulo: "", itens: [""] }],
          contatos: op.contatos?.length
  ? op.contatos.map((c) => ({
      id: crypto.randomUUID(),
      telefone: c.telefone || "",
      email: c.email || "",
      redeSocial: c.redeSocial || "",
    }))
  : [
      {
        id: crypto.randomUUID(),
        telefone: "",
        email: "",
        redeSocial: "",
      },
    ],

          imagem: op.imagem || null,
          preview: getImagemUrl(op.imagem),
          vagas: op.vagas || null,
          sobreEmpresa: op.sobreEmpresa || "",
          likes: op.likes || 0,
        });
      } catch (error) {
        console.error("Erro ao buscar oportunidade:", error);
        alert("Oportunidade não encontrada.");
        navigate("/oportunidades");
      } finally {
        setLoading(false);
      }
    };

    fetchOportunidade();
  }, [id, navigate]);

  const handleSave = async () => {
    if (!oportunidadeData) return;

    if (
      !oportunidadeData.titulo ||
      !oportunidadeData.empresa ||
      !oportunidadeData.cargo ||
      !oportunidadeData.dataInicio ||
      !oportunidadeData.dataFim
    ) {
      alert("Preencha título, empresa, cargo e datas de início e fim.");
      return;
    }

    const formData = new FormData();
    formData.append("titulo", oportunidadeData.titulo);
    formData.append("descricao", oportunidadeData.descricao);
    formData.append("organizador", oportunidadeData.organizador);
    formData.append("empresa", oportunidadeData.empresa);
    formData.append("cargo", oportunidadeData.cargo);
    formData.append("local", oportunidadeData.local);
    formData.append("status", oportunidadeData.status);
    formData.append("salario", oportunidadeData.salario);
    formData.append("horaTrabalho", oportunidadeData.horaTrabalho);
    formData.append("dataInicio", dayjs(oportunidadeData.dataInicio).toISOString());
    formData.append("dataFim", dayjs(oportunidadeData.dataFim).toISOString());
    formData.append("conteudos", JSON.stringify(oportunidadeData.conteudos));
    formData.append("contatos", JSON.stringify(oportunidadeData.contatos));
    formData.append("destacado", String(oportunidadeData.destacado));
    formData.append("vagas", oportunidadeData.vagas !== null ? String(oportunidadeData.vagas) : "null");
    formData.append("sobreEmpresa", oportunidadeData.sobreEmpresa);
    formData.append("likes", String(oportunidadeData.likes || 0));

    if (oportunidadeData.imagem instanceof File) {
      formData.append("imagem", oportunidadeData.imagem);
    }

    try {
      const response = await api.put(`/api/content/oportunidades/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Oportunidade atualizada com sucesso!");
      navigate("/oportunidades");
    } catch (error) {
      console.error("Erro ao atualizar oportunidade:", error);
      alert("Erro ao salvar alterações.");
    }
  };

  if (loading) return <p style={{ padding: 40 }}>Carregando oportunidade...</p>;
  if (!oportunidadeData) return <p style={{ padding: 40 }}>Oportunidade não encontrada.</p>;

  return (
    <DashboardLayout>
      <Sidebar />
      <Container>
        <Header
          title="Editar oportunidade"
          description="Atualize as informações da oportunidade"
          breadcrumbMain="oportunidades"
          breadcrumbCurrent="Editar oportunidade"
        />
        <MainContent>
          <Midia
            initialPreview={oportunidadeData.preview}
            onFileSelect={(file, preview) =>
              setOportunidadeData({ ...oportunidadeData, imagem: file, preview })
            }
          />

          <DetalhesOportunidade
            oportunidadeData={oportunidadeData}
            setOportunidadeData={setOportunidadeData}
          />

          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
